import { render, staticRenderFns } from "./LotCurrentPrice.vue?vue&type=template&id=62094e98&scoped=true"
import script from "./LotCurrentPrice.vue?vue&type=script&lang=js"
export * from "./LotCurrentPrice.vue?vue&type=script&lang=js"
import style0 from "./LotCurrentPrice.vue?vue&type=style&index=0&id=62094e98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62094e98",
  null
  
)

export default component.exports